export enum PenaltyType {
  TICKET_TRANSFER = "TICKET_TRANSFER",
  RULE_VIOLATION = "RULE_VIOLATION",
}
